import { __decorate, __metadata } from "tslib";
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { PMOTeamListModel } from "@/store/models/cycle/pmoTeamListDTO";
let TeamOverviewComponents = /** @class */ (() => {
    var _a;
    let TeamOverviewComponents = class TeamOverviewComponents extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Team Overview";
        }
        get teamName() {
            return this.team.name;
        }
        get teamMemberList() {
            return this.team.employeeReviews;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PMOTeamListModel !== "undefined" && PMOTeamListModel) === "function" ? _a : Object)
    ], TeamOverviewComponents.prototype, "team", void 0);
    TeamOverviewComponents = __decorate([
        Component({
            name: "TeamOverviewComponents",
        })
    ], TeamOverviewComponents);
    return TeamOverviewComponents;
})();
export default TeamOverviewComponents;
